const $ = jQuery.noConflict();

class Slider {
    constructor(selector, args = {}) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        };
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign({}, this.getDefaultSlickSettings(), this.args);
    }

    init() {
        if (!$(this.selector).not('.slick-initialized').length) {
            return;
        }
        let settings = this.getSlickSettings();

        $(this.selector).slick(settings);
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider', {
    dots: true,
});
const TestimonialSlider = new Slider('.js-testimonial-slider', { dots: true });
const FluidSlider = new Slider('.gallery-slider__slider-fluid', {
    variableWidth: true,
    dots: true,
});
const InitiativesSlider = new Slider('.isci-initiatives__slider', {
    variableWidth: true,
    dots: true,
});
export { SimpleSlider, FluidSlider, InitiativesSlider };
